<template>
  <div class="ChooseCreateWayModal">

    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('send_pagements.new_payment')" width="739px">
      <div class="choose-way-title">
        {{ $t('send_pagements.create_payment_disbursement') }}
      </div>
      <div class="item-container" @click="onClickSingleDisbursementBtn">
        <el-card shadow="hover">
          <div class="item-title color-main-linear-blue">
            {{ $t('send_pagements.single_disbursement') }}
          </div>
          <p class="item-content">
            {{ $t('tips.send_money_single_bank_account') }}
          </p>
        </el-card>
      </div>
      <div v-if="$store.getters.isHasAuth('AUTH_CODE_BATCH_PAYMENT')" class="item-container" @click="onClickBatchDisbursementBtn">
        <el-card shadow="hover">
          <div class="item-title color-main-linear-blue">
            {{ batchDisbursementTitle }}
          </div>
          <p class="item-content">
            {{ $t('tips.send_money_multipl_bank_accounts') }}
          </p>
        </el-card>
      </div>
    </el-dialog>
    <BatchPayoutModal ref="batchDisbursementModal" @showChooseModal="showModal" v-on="$listeners" />
    <SinglePayoutCreateModal ref="singlePayoutCreateModal" @showChooseModal="showModal" v-on="$listeners" />
  </div>
</template>

<script>
import SinglePayoutCreateModal from './SinglePayoutCreateModal.vue'
import BatchPayoutModal from './BatchPayoutModal.vue'
export default {
  name: 'Choose_Create_Disbursement_Way_Modal',
  components: {
    SinglePayoutCreateModal,
    BatchPayoutModal
  },
  data() {
    return {
      dialogVisible: false // 控制弹框显示隐藏
    }
  },
  computed: {
    getStandardPaymentLimitMapLabel() {
      return function(value) {
        return this.standardPaymentLimitMap(value).label
      }
    },
    batchDisbursementTitle() {
      return `${this.$t('send_pagements.batch_disbursement')} (${this.$t('tips.standard_payment_limit')} ${this.getStandardPaymentLimitMapLabel(this.$store.getters.curCountry.country_code)} ${this.$store.getters.curCountry.currency})`
    }
  },
  methods: {
    standardPaymentLimitMap(value) {
      const map = {
        PH: {
          value: 'PH',
          label: '50,000',
          mobileLength: 11,
          amount: 50000
        },
        TH: {
          value: 'TH',
          label: '50,000',
          mobileLength: 10,
          amount: 50000
        },
        ID: {
          value: 'ID',
          label: '250,000,000',
          mobileLength: 13,
          amount: 250000000
        },
        VN: {
          value: 'VN',
          label: '200,000,000',
          minLabel: '10,000',
          mobileLength: null,
          amount: 200000000,
          minAmount: 10000
        }
      }
      return map[value]
    },
    // 改变弹框状态
    showModal() {
      this.dialogVisible = true
    },
    onClickSingleDisbursementBtn() {
      this.dialogVisible = false
      this.$refs.singlePayoutCreateModal.showModal({ paymentType: 1 })
    },
    onClickBatchDisbursementBtn() {
      this.dialogVisible = false
      this.$refs.batchDisbursementModal.showModal()
    }

  }
}
</script>

<style scoped lang="scss">
.choose-way-title{
  color: #364250;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 48px;
}
.item-container{
  margin-bottom: 30px;
  cursor:pointer;
}
.item-title{
  font-size: 16px;
  font-weight: 600;
}
.item-content{
  font-size: 16px;
}

</style>
